import { Check } from 'lucide-react';
import { UserAvatar } from '../../components/UserAvatar';

/**
 * ContactItem — a single row in a contact list, supporting three modes:
 * plain tap-to-select, multi-select checkbox mode, and invite-a-non-user mode.
 *
 * Props:
 * - contact: Contact-shaped object — { avatarUrl, formattedName, primaryPhone }
 * - onClick: function — called when the row (or checkbox) is tapped
 * - isSelectedMode: bool — whether multi-select mode is active
 * - isSelected: bool — whether this contact is currently selected
 * - showCheckbox: bool — whether to show the selection circle when in select mode
 * - showInviteButton: bool — whether to show phone number + an "Invite" button
 * - onInvite: function — called when "Invite" is tapped (optional)
 */
export default function ContactItem({
  contact,
  onClick,
  isSelectedMode = false,
  isSelected = false,
  showCheckbox = false,
  showInviteButton = false,
  onInvite,
}) {
  return (
    <div>
      <div
        onClick={onClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '10px 16px',
          cursor: 'pointer',
        }}
      >
        <UserAvatar size={44} imageUrl={contact.avatarUrl} name={contact.formattedName} />
        <div style={{ width: 12, flexShrink: 0 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              color: '#fff',
              fontSize: 16,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {contact.formattedName}
          </div>
          {showInviteButton && (
            <div
              style={{
                color: '#9E9E9E',
                fontSize: 14,
                marginTop: 2,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {contact.primaryPhone}
            </div>
          )}
        </div>
        <div style={{ width: 10, flexShrink: 0 }} />
        <Trailing
          showCheckbox={showCheckbox}
          isSelectedMode={isSelectedMode}
          isSelected={isSelected}
          showInviteButton={showInviteButton}
          onInvite={onInvite}
        />
      </div>
      <div style={{ paddingLeft: 72 }}>
        <div style={{ height: 1, backgroundColor: '#2A2A2A' }} />
      </div>
    </div>
  );
}

function Trailing({ showCheckbox, isSelectedMode, isSelected, showInviteButton, onInvite }) {
  if (showCheckbox && isSelectedMode) {
    return (
      <div
        style={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          backgroundColor: isSelected ? '#5DC1F5' : '#757575',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {isSelected && <Check color="#fff" size={14} />}
      </div>
    );
  }

  if (showInviteButton) {
    return (
      <button
        onClick={(e) => {
          e.stopPropagation();
          onInvite?.();
        }}
        style={{
          background: 'none',
          border: 'none',
          padding: '8px 12px',
          cursor: 'pointer',
          flexShrink: 0,
        }}
      >
        <span style={{ color: '#4EA4F6', fontSize: 14, fontWeight: 600 }}>Invite</span>
      </button>
    );
  }

  return null;
}

export { ContactItem };